<template>
  <div
    class="region with-flyout  col-3 p-0"
    style="text-align: center"
  >
    <a
      class="_20yN1P wp_shareButton_productDetails"
      @click.prevent="toggleDropDown('share-select')"
      data-flyout="cbt-popUp"
      style="cursor: pointer"
						data-test="productShareLink"
						id="productShareLink"
    >
      <span style="white-space: nowrap;"
												data-test="productShareSvgSpan">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          class="pt-1"
										data-test="productShareSvg"
										id="productShareSvg"
        >
          <path
            d="M14.78 5.883L9.032 0v3.362C3.284 4.202.822 8.404 0
              12.606 2.053 9.666 4.927 8.32 9.032 8.32v3.446l5.748-5.883z"
            class="p5dWr2"
            fill="#c2c2c2"
            fill-rule="evenodd"
          >
          </path>
        </svg>
        Share
      </span>
    </a>
    <social-sharing
      :url='`http://womenpower.org.in${$route.fullPath}`'
      :title=$route.query.productName
      :quote="(product && product.product_details &&
                      product.product_details.short_description)?
                      product.product_details.short_description:''"
      hashtags="Techgentsia"
      twitter-user="TechgentsiaS"
      inline-template
    >
      <div
        class="flyout-share cbt-popUp"
        id="share-select"
      >
        <ul
          id="cbt-popUp"
          class="option2 mb-0"
        >
          <li class="popuplist">
            <div
              style=""
              class="p-1"
            >
              <network network="facebook">
                <i class="fab fa-facebook-f"
																			data-test="productShareFacebookIcon"></i>
                <label data-test="productShareFacebookLabel">
                  <b data-test="productShareFacebookBold">Facebook</b>
                </label>
              </network>
            </div>
          </li>
          <li class="popuplist">
            <div
              style=""
              class="p-1"
            >
              <network network="twitter">
                <i class="fab fa-twitter" data-test="productShareTwitterIcon"
																			id="productShareTwitterIcon"></i>
                <label data-test="productShareTwitterLabel"
																							id="productShareTwitterLabel">
                  <b data-test="productShareTwitterBold"
																					id="productShareTwitterBold">Twitter</b>
                </label>
              </network>
            </div>
          </li>
          <li class="popuplist">
            <div
              style=""
              class="p-1"
            >
              <network network="email">
                <i class="far fa-envelope"
																			data-test="productShareEmailIcon"
																			id="productShareEmailIcon"></i>
                <label data-test="productShareEmailLabel"
																							id="productShareEmailLabel">
                  <b data-test="productShareEmailBold"
																					id="productShareEmailBold">Email</b>
                </label>
              </network>
            </div>
          </li>
          <li class="popuplist">
            <div
              style=""
              class="p-1"
            >
              <network network="whatsapp">
                <i class="fab fa-whatsapp"
																			data-test="productShareWhatsAppIcon"
																			id="productShareWhatsAppIcon"></i>
                <label data-test="productShareWhatsAppLabel"
																							id="productShareWhatsAppLabel">
                  <b data-test="productShareWhatsAppBold"
																					id="productShareWhatsAppBold">Whatsapp</b>
                </label>
              </network>
            </div>
          </li>
        </ul>
      </div>
    </social-sharing>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import eventService from '../../../../services/DomEventServices/domEventServices'

export default {
	props: {
		product: {}
	},
	computed: {
		...mapGetters('siteData', ['getScreenWidth'])
	},
	methods: {
		iOSWebViewShare () {
			window.webkit.messageHandlers.productShare.postMessage(`http://womenpower.org.in${this.$route.fullPath}`)
		},
		toggleDropDown (dropDownId) {
			const isUiwebview = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(navigator.userAgent)
			if (isUiwebview) {
				this.iOSWebViewShare()
			} else if (this.getScreenWidth < 992) {
				if (navigator.userAgent.includes('wv')) {
					Android.shareViaSocialNetworks(`http://womenpower.org.in${this.$route.fullPath}`)
				} else {
					eventService.toggleDropDown(dropDownId)
					// document.querySelector('.with-flyout').classList.add('backdrop');
				}
			} else {
				eventService.toggleDropDown(dropDownId)
				if (this.getScreenWidth < 992) {
					document.querySelector('.with-flyout').classList.add('backdrop')
				}
			}
			// const ios = /iPhone|iPad|iPod/i.test(navigator.userAgent);
			// const android = /Android/i.test(navigator.userAgent);
			//
			// const browser = (function (agent) {
			//   switch (true) {
			//     case agent.indexOf('edge') > -1:
			//       return 'edge';
			//     case agent.indexOf('opr') > -1 && !!window.opr:
			//       return 'opera';
			//     case agent.indexOf('chrome') > -1 && !!window.chrome:
			//       return 'chrome';
			//     case agent.indexOf('trident') > -1:
			//       return 'ie';
			//     case agent.indexOf('firefox') > -1:
			//       return 'firefox';
			//     case agent.indexOf('safari') > -1:
			//       return 'safari';
			//     default:
			//       return 'other';
			//   }
			// }(window.navigator.userAgent.toLowerCase()));
			//
			// if ((android || ios) && browser) {
			//   eventService.toggleDropDown(dropDownId);
			//   if (this.getScreenWidth < 992) {
			//     document.querySelector('.with-flyout').classList.add('backdrop');
			//   }
			// } else if (android) {
			//   Android.shareViaSocialNetworks(`http://ecommerce.techgentsia.com${this.$route.fullPath}`);
			// } else {
			//   eventService.toggleDropDown(dropDownId);
			//   if (this.getScreenWidth < 992) {
			//     document.querySelector('.with-flyout').classList.add('backdrop');
			//   }
			// }
		},
		closeDropDown () {
			eventService.toggleDropDown('share-select')
			document.querySelector('.with-flyout').classList.remove('backdrop')
			//   document.querySelector('#share-select').style.display = 'none';
			//   document.querySelector('#share-select').classList.remove('open');
		}
	},
	mounted () {
		$('.popuplist').on('click', (e) => {
			document.querySelector('.with-flyout').classList.remove('backdrop')
			eventService.toggleDropDown('share-select')
		})
	}
}
</script>
